export default {
  title: 'Datos del cliente'
}
